import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/auth.service";
import { UserService } from "./../services/user.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('0')
    if (localStorage.getItem("authToken")) {

      console.log('1')
      // logged in so return true
      if (this.userService.user.getValue()) {
        this.authService.userInfo();
        return true;
      }
    }

    // not logged in so redirect to login page with the return url
    if (localStorage.getItem("page")) {
      console.log('2')
      localStorage.setItem("page", this.router.url);
    }
    console.log('3')
    this.router.navigate(["/auth/login"], {
      // queryParams: { returnUrl: state.url },
    });
    console.log('4')
    return false;
  }
}
